module.exports = __webpack_public_path__ + "static/img/FSK.4845a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/FSK.png
// module id = k8oS
// module chunks = 34